import { TranslatableNameCodebook } from '../TranslatableNameCodebook'
import { $t } from '../../composables/i18n'

export enum NoteTypeId {
  RECEPTION = 1,
  SYSTEM = 2,
  KITCHEN = 3,
  HOUSEKEEPING = 4,
}

export class NoteType extends TranslatableNameCodebook {
  static readonly RECEPTION = new NoteType(NoteTypeId.RECEPTION, $t('Reception'))
  static readonly SYSTEM = new NoteType(NoteTypeId.SYSTEM, $t('System'))
  static readonly KITCHEN = new NoteType(NoteTypeId.KITCHEN, $t('Kitchen'))
  static readonly HOUSEKEEPING = new NoteType(NoteTypeId.HOUSEKEEPING, $t('Housekeeping'))

  private constructor(
    public readonly id: NoteTypeId,
    name: string,
  ) {
    super(name)
  }

  static getById = (id: NoteTypeId): NoteType => {
    const noteType = NoteType.all().find((noteType) => noteType.id === id)

    if (noteType === undefined) {
      throw new Error($t('Note type with id {id} not found', { id }))
    }

    return noteType
  }

  static all = (): NoteType[] => {
    return [NoteType.RECEPTION, NoteType.SYSTEM, NoteType.KITCHEN, NoteType.HOUSEKEEPING]
  }
}
